import { IItemToRequest, MyPurchaseForm } from "src/app/shared/models/app-models";
import { Item, BudgetAllocation, AddOn, Vendor, TaggedGroup } from "src/app/shared/models/database-models/SaveMyPurchase.model";
import { checkIfProjectRORequired } from "./derive-budget-allocations";
import { PurchaseType, PurchaseTypeMap } from "src/app/shared/models/app-models/Approving.model";
import { GroupStatus, TaggedGroups } from "../../mypurchase-form/rfs/tag-item-vendor.service";

export const itemListFrontendToBackendMapper = (itemList: IItemToRequest[], form: MyPurchaseForm): Item[] => {
    let ItemList: Item[] = [];
    let purchaseType = form.PurchaseTypeId ? PurchaseTypeMap[form.PurchaseTypeId] : null;

    let isProjectAoRequired = checkIfProjectRORequired(itemList.flatMap(x => x.BudgetAllocation), itemList, false)
    for (const item of itemList) {
      if (!item.AddItems.PurchaseItemId && item.isDeleted) continue
      let purchaseItemId = item.AddItems.PurchaseItemId
      let itemToReturn: Item = {
        item: {
          PurchaseItemId: purchaseItemId,
          ItemNumber: item?.AddItems?.displayItemNumber ?? null,
          IsSML: item.AddItems.IsSML,
          SMLReasonId: item.AddItems.SMLReasonId
            ? item.AddItems.SMLReasonId.value
            : null,
          ItemDescription: item.AddItems.ItemDescription,
          PartModelNumber:
            item.AddItems.PartModelNumber == ''
              ? null
              : item.AddItems.PartModelNumber,
          BrandOEMName: item.AddItems.BrandOEMName
            ? item.AddItems.BrandOEMName.id
            : null,
          OtherBrandOEMName: item.AddItems?.BrandOEMNameCustom || null,
          MaterialGroupId: item?.AddItems?.MaterialGroupId
            ? item.AddItems.MaterialGroupId.Code
            : null,
          MaterialGroupName: item?.AddItems?.MaterialGroupId?.Name ?? null,
          MaterialSubGroupId: item?.AddItems?.MaterialSubGroupId
            ? item.AddItems.MaterialSubGroupId.Code
            : null,
          MaterialSubGroupName: item?.AddItems?.MaterialSubGroupId?.Name ?? null,
          IsGEWCA: item?.AddItems?.MaterialSubGroupId?.IsGEWCA ?? false,
          RestrictedITProductPolicy:
            purchaseType &&
            ([
              PurchaseType.RFQ,
              PurchaseType.TENDER,
              PurchaseType.DC,
              PurchaseType.CORPORATE_CARD,
              PurchaseType.PCPO,
              PurchaseType.PERMISSIBLE_COVERING
            ] as string[]).includes(purchaseType) &&
            item?.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase().includes(
              'cat'
            )
              ? item?.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy
              : null,
          PurchaseExecutiveId: null,
          PurchaseExecutive: item?.AddItems?.PurchaseExecutive ?? null,
          isSingleBudget: item.AddItems.isSingleBudget,
          PlannedDeliveryDate: item.AddItems.PlannedDeliveryDate,
          // MaintenanceStartDate: item.AddItems.MaintenanceStartDate,
          // MaintenanceEndDate: item.AddItems.MaintenanceEndDate,
          isCOTS: item.AddItems.isCOTS
            ? item.AddItems.isCOTS.value == 'COTS'
              ? true
              : false
            : null,
          isObsolete: null,
          isSourcingSuccessful: null,
          Criticality: item.AddItems.CriticalityId
            ? item.AddItems.CriticalityId.value
            : null,
          WorkmanshipStandard: item.AddItems.WorkmanshipId
            ? item.AddItems.WorkmanshipId.value
            : null,
          SourcingStatusId: item.AddItems.SourcingStatusId ?? null,
          TaggedVendors: item.AddItems.TaggedVendors ?? null,
          ReferenceId: item.AddItems.ReferenceId ?? null,
          Strikethrough: item.Strikethrough,
          AnnualMaintenanceCost: item.AddItems.AnnualMaintenanceCost ?? null,
          EstimatedUsageId: item.AddItems.EstimatedUsageId?.EstimatedUsageId ?? null,
          IsSupportingNonFundingProject: item.AddItems.IsSupportingNonFundingProject ?? null,
          SupportingInformation: item.AddItems.SupportingInformation ?? null,
          IsAdditionalSpaceRequired: item.AddItems.IsAdditionalSpaceRequired ?? null,
        },
        itemPrice: {
          UnitOfMeasurement: item.ItemPrice.UnitOfMeasurement.value,
          Quantity: item.ItemPrice.Quantity,
          Per: item.ItemPrice.UnitsPerQuantity
            ? item.ItemPrice.UnitsPerQuantity.toString()
            : null,
          CurrencyCode: item.ItemPrice.Currency.value,
          EstimateUnitPrice: item.ItemPrice.UnitPrice,
          ExchangeRate: item.ItemPrice.ExchangeRate,
        },
        budgetAllocation: [],
        isDeleted: item.isDeleted,
        AddOnFeature:
          handleTranformAddOn(item?.AddOnFeature || [], {
            PurchaseItemId: item?.AddItems?.PurchaseItemId || null,
            UnitOfMeasurements: item.ItemPrice.UnitOfMeasurement.value,
            CurrencyCode: item.ItemPrice.Currency.value,
            EstimatedUnitPrice: item.ItemPrice.UnitPrice,
            Description: item.AddItems.ItemDescription,
          }) || [],
      };

      // pushing in all the budgets for this item
      for (const budget of item.BudgetAllocation) {
        //no need to send back soft deleted budgets for newly created items
        if (!purchaseItemId && budget.isDeleted) continue;
        let budgetType = budget.BudgetType.value.trim().toLowerCase();
        // this one is kinda unintuitive since we allow users to save null values....
        let isBudgeted = budget.BudgetExpenditureUsage
          ? budget.BudgetExpenditureUsage.id == true
            ? true
            : false
          : null;
        let isRecurrent = budget.BudgetFrequencyUsage
          ? budget.BudgetFrequencyUsage.id == true
            ? true
            : false
          : null;
        let budgetToReturn: BudgetAllocation = {
          CVFundCentre:
            budgetType == 'capital' ? budget.FundCentre?.id ?? null : null,
          CVGLAccount:
            budgetType == 'capital' ? budget.GLAcc?.id ?? null : null,
          CVIsBudgeted: budgetType == 'capital' ? isBudgeted : null,
          CVApprovalBoardEx: null,
          CAUCVCapitalBudget:
            budgetType == 'capital auc'
              ? budget.ProjectBudget?.id ?? null
              : null,
          CAUCVGLAccount:
            budgetType == 'capital auc' ? budget.GLAcc?.id ?? null : null,
          CAUCVIsBudgeted: budgetType == 'capital auc' ? isBudgeted : null,
          OVIsRecurrent: budgetType == 'operating' ? isRecurrent : null,
          OVCostCentre:
            budgetType == 'operating' ? budget.CostCentre?.id ?? null : null,
          OVGLAccount:
            budgetType == 'operating' ? budget.GLAcc?.id ?? null : null,
          OVAccountNumber: null,
          OVOrderNumber:
            budgetType == 'operating' ? budget.OrderNo?.value ?? null : null,
          OvIsBudgeted: budgetType == 'operating' ? isBudgeted : null,
          PVProjectCodeName:
            budgetType == 'project' ? budget.ProjectCode?.id : null,
          PVProjectBudget:
            budgetType == 'project' ? budget.ProjectBudget?.id : null,
          PVGLAccount: budgetType == 'project' ? budget.GLAcc?.id : null,
          DistributionPercent: item.AddItems.isSingleBudget
            ? 100
            : budget.Quantity
              ? null
              : budget.Percentage,
          DistributionQuantity: budget.Quantity,
          BudgetType: budget.BudgetType.value,
          ItemBudgetId:
            budget.BudgetItemId == 0 || budget.BudgetItemId == null
              ? null
              : budget.BudgetItemId,
          // Temp Prod Fix
          PVApprovingOfficer: budget.ApprovingOfficer,
          // PVApprovingOfficer: isProjectAoRequired ? budget.ApprovingOfficer : null,
          isDeleted: budget.isDeleted,
          IsExemptedAOR: budgetType == 'operating' ? item?.AddItems?.MaterialSubGroupId?.IsExemptedAOR ?? false : false,
          Strikethrough: budget.Strikethrough
        };
        itemToReturn.budgetAllocation.push(budgetToReturn);
      }

      ItemList.push(itemToReturn);
    }

    return ItemList;
  }
  export const handleTranformAddOn = (addOn: AddOn[], data: any)=> {
    const {
      PurchaseItemId,
      UnitOfMeasurements,
      CurrencyCode,
      EstimatedUnitPrice,
      Description,
    } = data;
    const newAddOn = addOn?.map(({ itemId, ...item }: AddOn) => {
      return {
        ...item,
        isDeleted: item.isDeleted || false,
        PurchaseItemId,
        UnitOfMeasurements,
        CurrencyCode,
        EstimatedUnitPrice,
        Description,
      };
    });
    return newAddOn;
  }

  export const taggedGroupsFrontendToBackendMapper = (taggedGroups: TaggedGroups['taggedGroups']) => {
    return taggedGroups.map(taggedGroup => {
      const {taggedGroupId, itemNumbers, vendors, sourcingStatusId, groupStatus} = taggedGroup
      const formatted: TaggedGroup = {
        TaggedGroupId: taggedGroupId,
        ItemNumbers: itemNumbers,
        VendorNumbers: vendors?.map(vendor => vendor.vendorNumber) ?? [],
        SourcingStatusId: sourcingStatusId ?? null,
        IsDeleted: [GroupStatus.DELETED, GroupStatus.PERSISTED_INACTIVE].includes(groupStatus)
      }
      return formatted 
    })
  }

  export const vendorsListFrontendToBackendMapper = (vendors?: Vendor[]) => {
    if (!vendors) {
      return []
    }

    return vendors.map(vendor => ({
      ...vendor,
      Email: (vendor.Email !== '' && vendor.Email !== '-') ? vendor.Email : null,
      OtherPersonEmail:
        (vendor.OtherPersonEmail !== '' && vendor.OtherPersonEmail !== '-') ? vendor.OtherPersonEmail : null,
      OtherPersonName:
        (vendor.OtherPersonName !== '' && vendor.OtherPersonName !== '-') ? vendor.OtherPersonName : null,
      VendorContactPerson:
        (vendor.VendorContactPerson !== '' && vendor.VendorContactPerson !== '-') ? vendor.VendorContactPerson : null,
    }))
  }